import { render, staticRenderFns } from "./special-add.vue?vue&type=template&id=7c7fcaaa&scoped=true&"
import script from "./special-add.vue?vue&type=script&lang=ts&"
export * from "./special-add.vue?vue&type=script&lang=ts&"
import style0 from "./special-add.vue?vue&type=style&index=0&id=7c7fcaaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7fcaaa",
  null
  
)

export default component.exports